<template>
    <div>
        <div class="Bgcolor">
<div class="info">
    <div class="name_phone">
        <div> <span class="redLi">*</span> 联系人</div>
        <el-input v-model="form.contactName" placeholder="请输入内容"></el-input>
    </div>
    <div class="name_phone">
        <div><span class="redLi">*</span>电话号码</div>
        <el-input v-model="form.phoneNumber" placeholder="请输入内容"></el-input>
    </div>
    <div class="name_phone">
        <div><span class="redLi">*</span>企业名称</div>
        <el-input v-model="form.companyName" placeholder="请输入内容"></el-input>
    </div>
</div>
<div class="cityInfo">
    <div style="padding-left: 5px;">所在城市</div>
    <!-- <el-input v-model="form.city" placeholder="请输入内容"></el-input> -->


    <el-cascader style="width: 100%;"
      size="large"
      :options="options"
      v-model="city"
      @change="handleChange"
      ref="cascaderRef">
    </el-cascader>


        </div> 
        <div class="cityInfo">
    <div style="padding-left: 5px;">业务场景</div>
    <el-input  type="textarea"
  :autosize="{ minRows: 4, maxRows: 8}"
  placeholder="请输入内容" v-model="form.businessScenario" ></el-input>
</div>
<div class="upBtn">
          <el-button type="danger" class="btnStyle" @click="sureInfo">确认提交</el-button>
    </div>
    </div>
  
    </div>
</template> 
 <script>
 
  import { regionDataPlus , CodeToText} from 'element-china-area-data'
    export default {
      name: 'PageFive',// 使用多词名称
  
      data() {
        return {
            city:'',
            form:{
                // id:'77',
                contactName:'',
                phoneNumber:'',
                companyName:'',
                city:'',
                businessScenario:'',
            },
          activeName: 'second',
        options: regionDataPlus,

        };
      },
      methods: {
        handleChange(value) {
 // 方式1：编码转文本
// let textChain = value.map(code => CodeToText[code]);
      
      // 方式2：获取节点对象
      const textChain = value.map(code => CodeToText[code]);
      console.log(textChain); 
      this.form.city = textChain.join('-'); // 输出"1-2-3"
      console.log(this.form.city); 

            },

            // 信息提交
            sureInfo(){
      console.log(this.form,"提交前数组"); 

                if(!this.form.contactName){
                    this.$message.error('请输入联系人姓名');
                    return
                }
                if(!this.form.phoneNumber){
                    this.$message.error('电话号码不能为空');
                    return

                }
                if(!this.form.companyName){
                    this.$message.error('企业名称不能为空');
                    return

                }
      this.axios({
        url:'https://koala.hengyuanxx.com/sqx_fast/app/customerRequests/add',
       method: 'post',
       data:this.form,

      }).then(res => {
    
        console.log(res)
        if(res.data.code==0){
            this.$message({
          message: '提交成功',
          type: 'success'
        });
        this.form={}
        }
      })
    
    }

                // this.$axios.post('/app/customerRequests/add', this.form).then( res => {
                //         console.log(res,this.form,"发送请求")
                //     }
                // )

      }
            
      
    };
  </script>
  
  <style scoped>
  .Bgcolor{
    background: #F4F8FB;
  }
  .info{
    padding: 50px 0;
    display: flex;
    justify-content: space-between;
    margin: 0px auto;
    width: 50%;
  }
  .name_phone{
    display: flex;
    width: 30%;
    flex-direction: column;
    align-items: flex-start;
  }
  .redLi{
    color: #FF2C27;
    padding-left: 5px;
  }
  .cityInfo{

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0px auto;
    width: 50%;
    padding-bottom: 50px;


  }
  .upBtn{
    width: 100%;
    padding-bottom: 50px;
  }
  .btnStyle{
    width: 200px;
    background: #FF2C27;
    font-size: 16px;
color: #FFFFFF;
  }
  </style>